// extracted by mini-css-extract-plugin
export var editInput = "_gk-0";
export var editInputCompact = "_gk-2";
export var editInputLarge = "_gk-1";
export var editInputSmall = "_gk-3";